import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	CircularProgress,
	Box,
	Typography
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Select from 'react-select/creatable';

const UpdateWalletTransactionDialog = ({
	                                       open,
	                                       onClose,
	                                       onSubmit,
	                                       orderNumber,
	                                       setOrderNumber,
	                                       recentOrders,
	                                       recentOrderLoading,
	                                       isSubmitting,
	                                       selectedTransaction
                                       }) => {
	const customStyles = {
		control: (base, state) => ({
			...base,
			border: 'none',
			borderBottom: `2px solid #000000`,
			borderRadius: 0,
			boxShadow: 'none',
			backgroundColor: 'transparent',
			'&:hover': {
				borderBottom: '2px solid #0539b2',
			},
			minHeight: '36px',
		}),
		input: (base) => ({
			...base,
			margin: 0,
			padding: 0,
		}),
		placeholder: (base) => ({
			...base,
			color: '#aaa',
			fontSize: '14px',
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: state.isFocused ? '#f5f5f5' : 'white',
			color: '#333',
			fontSize: '14px',
		}),
		menuPortal: (base) => ({
			...base,
			zIndex: 9999,
		}),
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>
				<Box display="flex" alignItems="center">
					<EditIcon
						fontSize="medium"
						style={{marginRight: 8, color: '#3f51b5'}}
					/>
					Update Wallet Transaction
				</Box>
			</DialogTitle>
			<DialogContent dividers>
				{selectedTransaction && (
					<Box mb={2}>
						<Typography variant="subtitle2" color="textSecondary">
							Transaction ID: {selectedTransaction.id}
						</Typography>
						<Typography variant="subtitle2" color="textSecondary">
							Current Order Number: {selectedTransaction.order_number || 'Not set'}
						</Typography>
					</Box>
				)}
				{!recentOrderLoading && (
					<Box>
						<Typography variant="caption" color="textSecondary" gutterBottom>
							Order Number
						</Typography>
						<Select
							options={recentOrders}
							styles={customStyles}
							placeholder="Select or enter order number"
							onKeyDown={(e) => {
								if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
									e.preventDefault();
								}
							}}
							value={orderNumber}
							onChange={setOrderNumber}
							isClearable
							isDisabled={isSubmitting}
							menuPortalTarget={document.body}
							menuPosition="fixed"
						/>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={isSubmitting} color="default">
					Cancel
				</Button>
				<Button onClick={onSubmit} disabled={isSubmitting} color="primary" variant="contained">
					{isSubmitting && (
						<CircularProgress size={16} color="inherit" style={{marginRight: 8}}/>
					)}
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default UpdateWalletTransactionDialog;
